import React from "react";
import { message, Form, Checkbox } from "antd";
import styled from "styled-components";
import { PlusOutlined } from "@ant-design/icons";

import Button from "components/buttons/Button";
import Upload from "components/buttons/Upload";
import Input from "components/inputs/Input";
import NumberInput from "components/inputs/NumberInput";
import Fetch from "components/Fetch";
import colors from "constants/palette";
export default function Brands({ setData, oldData, handleCancel }) {
  const [form] = Form.useForm();

  let initialLogo = oldData?.logo;

  const [loading, setLoading] = React.useState(false);
  const [changeAll, setChangeAll] = React.useState(false);
  const [image, setImage] = React.useState(initialLogo ? [initialLogo] : []);
  console.log(image);
  const onSubmit = (data) => {
    const submitData = {
      ...data,
      logo: image[0],
      data: JSON.stringify({}),
      changeAll: changeAll,
      oldTitle: oldData && oldData.title,
    };
    setLoading(true);
    if (!oldData) {
      // new :::::::::::::
      Fetch.post("/brand", submitData, (res) => {
        console.log("new brand response", res);
        if (res?.id) {
          message.success("با موفقیت اضافه شد");
          cleanForm();
          setImage([]);
          setData((e) => [...e, res]);
        } else {
          if (res?.errors.title) {
            message.error(res?.errors.title[0]);
          } else {
            message.error("خطایی رخ داده است");
          }
        }
      });
    } else {
      // update :::::::::
      Fetch.put(`/brand/${oldData.id}`, submitData, (res) => {
        console.log("new brand response/UPDATE", res);
        if (res?.id) {
          message.success("با موفقیت آپدیت شد");

          setData((e) => {
            var newData = e;
            newData[e.findIndex((item) => item.id === res.id)] = res;
            console.log("newData", newData);
            return newData;
          });

          handleCancel();
          cleanForm();
        } else {
          if (res?.errors?.title) {
            message.error(res?.errors.title[0]);
          } else {
            message.error("خطایی رخ داده است");
          }
        }
      });
    }
    setLoading(false);
  };

  function cleanForm() {
    form.resetFields();
    setImage([]);
  }
  if (oldData) {
    form.setFieldsValue(oldData);
  }

  console.log(image);
  return (
    <Form
      form={form}
      layout="vertical"
      style={{ direction: "rtl" }}
      name={oldData ? "update" : "new"}
      onFinish={onSubmit}
    >
      <Label>نام برند :</Label>
      <Form.Item
        name="title"
        rules={[
          {
            required: true,
            message: "لطفا نام برند را وارد کنید!",
          },
        ]}
      >
        <Input size="large" placeholder="" />
      </Form.Item>
      <Label>تلفن :</Label>
      <Form.Item name="phone">
        <NumberInput style={{ width: "100%" }} />
      </Form.Item>

      {/* <AntInput.TextArea rows={5} /> */}
      <Label>آدرس شرکت :</Label>
      <Form.Item name="address">
        <Input size="large" placeholder="" />
      </Form.Item>
      <Upload
        maxAllowed={1}
        setImage={setImage}
        addedImages={image}
        key={oldData ? oldData.id : "new"}
      />

      {oldData && (
        <p style={{ color: colors.dark }}>
          به روز رسانی محصولات با نام برند جدید :{" "}
          <Checkbox
            checked
            onChange={({ target }) => setChangeAll(target.checked)}
          />
        </p>
      )}
      <Button
        loading={loading}
        htmlType="submit"
        style={{ width: "100%", marginTop: 16 }}
      >
        {oldData ? (
          "اصلاح"
        ) : (
          <span>
            <PlusOutlined style={{ marginLeft: 8 }} />
            اضافه کردن
          </span>
        )}
      </Button>
    </Form>
  );
}
const Label = styled.label`
  margin-bottom: 10px;
  display: block;
  color: ${colors.dark};
`;
